import { render } from "./TagsIndex.vue?vue&type=template&id=fbf3d7ac"
import script from "./TagsIndex.vue?vue&type=script&lang=js"
export * from "./TagsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__